/* globals fetch */
export const getPostArea = bodyObj => {
    return new Promise((resolve, reject) => {
        post('/medl/hent_poststed.php', bodyObj)
            .then(response => {
                if (response.ok && response.data.resultat === 'OK') resolve(response.data);
                else resolve({});
            })
            .catch(err => reject(err));
    });
};

export const getOrderById = bodyObj => {
    return new Promise((resolve, reject) => {
        post('/medl/hent_ordre.php', bodyObj)
            .then(response => {
                if (response.ok && response.data.resultat === 'OK') resolve(response.data);
                else resolve({});
            })
            .catch(err => reject(err));
    });
};

export const updatePersonMyPage = bodyObj => {
    return new Promise((resolve, reject) => {
        post('/medl/minside_person_update.php', bodyObj)
            .then(response => {
                if (response) resolve(response);
                else resolve({});
            })
            .catch(err => reject(err));
    });
};

export const updatePersonNo = bodyObj => {
    return new Promise((resolve, reject) => {
        post('/medl/profil_fodselsnr.php', bodyObj)
            .then(response => {
                if (response && response.success) resolve(response);
                else resolve({});
            })
            .catch(err => reject(err));
    });
};

export const getPerson = bodyObj => {
    return new Promise((resolve, reject) => {
        post('/medl/hent_person.php', bodyObj)
            .then(response => {
                if (response.ok && response.data && response.data.data) {
                    resolve(response.data.data);
                } else {
                    resolve({});
                }
            })
            .catch(e => {
                reject(e);
            });
    });
};

export const emailAbo = (epost, industry, api) => {
    const postUri = api || '/medl/epost-abo.php';

    const errorMessage = 'Noe gikk galt med innsending av e-post. Prøv igjen senere.';

    return new Promise((resolve, reject) => {
        post(postUri, { epost, industry })
            .then(response => {
                if (response && response.ok) {
                    resolve(response.message || 'Takk for at du meldte deg på nyhetsbrevet vårt!');
                } else if (response.feedback) {
                    resolve(response.feedback.result || errorMessage);
                } else {
                    resolve(errorMessage);
                }
            })
            .catch(e => {
                reject(e);
            });
    });
};

export const emailAboFremtidsf = epost => {
    const postUri = '/medl/epost-abo-fremtidsf.php';

    const errorMessage = 'Noe gikk galt med innsending av e-post. Prøv igjen senere.';

    return new Promise((resolve, reject) => {
        post(postUri, { epost })
            .then(response => {
                if (response && response.success) {
                    resolve(response || 'Takk for at du meldte deg på nyhetsbrevet vårt!');
                } else if (!response.success) {
                    resolve(response || errorMessage);
                } else {
                    resolve(errorMessage);
                }
            })
            .catch(e => {
                reject(e);
            });
    });
};

export const webinarSignup = (epost, popupId, samtSms, samtEpost) => {
    const postUri = '/medl/pameld_arr.php';

    const errorMessage = 'Noe gikk galt med innsending av e-post. Prøv igjen senere.';

    return new Promise((resolve, reject) => {
        post(postUri, { epost, arrid: popupId, samt_sms: samtSms, samt_epost: samtEpost })
            .then(response => {
                if (response && response.success) {
                    resolve(response || 'Takk for at du meldte deg på webinaret vårt!');
                } else if (!response.success) {
                    resolve(response || errorMessage);
                } else {
                    resolve(errorMessage);
                }
            })
            .catch(e => {
                reject(e);
            });
    });
};

export const login = mobilnr => {
    return new Promise((resolve, reject) => {
        post('/medl/login_api.php', { mobilnr })
            .then(response => {
                resolve();
                // if (response.ok) {
                // } else {
                //     reject(new TypeError('Ingen støttemedlemsdata'));
                // }
            })
            .catch(reject);
    });
};

export const loginNoRedirect = (mobilnr, code) => {
    return new Promise((resolve, reject) => {
        fetch('/medl/login_api_code.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ mobilnr, code })
        })
            .then(res => res.json())
            .then(response => {
                resolve(response);
            })
            .catch(err => {
                reject(err);
            });
    });
};

export const registrerMember = formData => {
    return new Promise((resolve, reject) => {
        post('/medl/giver_create_2.php', formData)
            .then(response => {
                if (response && response.ok) {
                    resolve('Takk for at du meldte deg på nyhetsbrevet vårt!');
                } else {
                    reject(new Error('Registreringen feilet'));
                }
            })
            .catch(e => {
                reject(e);
            });
    });
};

export const searchPerson = name => {
    return new Promise((resolve, reject) => {
        fetch('/wp-json/snla/v1/ansatt/' + name, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => res.json())
            .then(response => {
                resolve(response);
            })
            .catch(err => {
                reject(err);
            });
    });
};

export const fixLoginNoRedirect = (phoneNumber, code, changeData, onFail) => {
    return new Promise((resolve, reject) => {
        const noSpacePhoneNumber = phoneNumber.replace(/\s/g, '');
        const validPhone = /^\+?\d{8,12}$/.test(noSpacePhoneNumber);

        if (validPhone) {
            loginNoRedirect(noSpacePhoneNumber, code)
                .then(response => {
                    if (response.ok && response.user) {
                        changeData(response.user);
                        resolve(true);
                    } else {
                        onFail(true);
                    }
                })
                .catch(e => {
                    reject(e);
                });
        } else {
            resolve(validPhone || phoneNumber === '');
        }
    });
};

export const getUserFromPhoneNumber = (
    phoneNumber,
    ignoredLogin,
    setIgnoredLogin,
    setShouldLogin,
    changeData,
    lookupEvent
) => {
    return new Promise((resolve, reject) => {
        const noSpacePhoneNumber = phoneNumber.replace(/\s/g, '');

        const validPhone = /^\+?\d{8,12}$/.test(noSpacePhoneNumber);

        if (validPhone && ignoredLogin.phone !== phoneNumber) {
            getPerson({ mobilnr: noSpacePhoneNumber })
                .then(response => {
                    setIgnoredLogin({ ...ignoredLogin, phone: phoneNumber });
                    if (
                        response.type &&
                        response.type === 'medlem' &&
                        !(ignoredLogin.ignored && ignoredLogin.phone === noSpacePhoneNumber)
                    ) {
                        // kall API for å få medlemsinfo
                        login(noSpacePhoneNumber).then(() => {
                            setShouldLogin(true);
                            changeData(response);
                            resolve(true);
                        });
                    } else if (Object.keys(response).length > 0) {
                        changeData(response);
                        resolve(true);
                    } else resolve(true);

                    lookupEvent('success');
                })
                .catch(e => {
                    lookupEvent('failed');

                    reject(e);
                });
        } else {
            setIgnoredLogin({ ...ignoredLogin, phone: phoneNumber });
            resolve(validPhone || phoneNumber === '');
        }
    });
};

export const post = (url, body) => {
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body || {})
        })
            .then(res => res.json())
            .then(response => {
                resolve(response);
            })
            .catch(err => {
                reject(err);
            });
    });
};
